module.exports = __webpack_public_path__ + "img/last-backend.e91c3e0a.svg";